import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { Page } from '../model/Page';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileResponseModel } from '../model/FileResponseModel';
import { AllotmentLetterListModel } from '../model/AllotmentLetterListModel';
import { LetterListModel } from '../model/LetterListModel';
import { CasteValVerificationListModel } from '../model/CasteValVerificationListModel';
import { AppealDetailModel } from '../model/AppealDetailModel';
import { InstallmentExtendModel } from '../model/InstallmentTypeModel';
import { InstallmentAppealModel } from '../model/InstallmentAppealModel';
import { PaymentSettlementModel } from '../model/PaymentSettlementModel';
import { PaymentSettlementModelPageWrapper } from '../model/PaymentSettlementModelPageWrapper';

@Injectable({
  providedIn: 'root'
})
export class OfficialsService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  initPage() {
    return this.httpClient.get<{lotteryList: {[key: number]: string}, status: string, errorMessage: string}>(ApiUrls.officialsListInitUrl);
  }

  fetchSchemeForLotteryEvent(lotteryEventId: number) {
    return this.httpClient.get<{schemeList: {[key: number]: string}, status: string, errorMessage: string}>(
      ApiUrls.officialsListFetchSchemeByLotteryUrl.replace('{lotteryEventId}', lotteryEventId.toString()));
  }

  fetchApplicationListForLetterType(page: number,
    size: number, lotteryEventId: number, schemeId: number, filterText: string) {
    return this.httpClient.get<{data: Page<CasteValVerificationListModel>, status: string, errorMessage: string}>(
        ApiUrls.officialsListFetchPageByFilterUrl 
        + `?page=${page}&size=${size}`
        + `&lotteryEventId=${lotteryEventId}`
        + (schemeId ? `&schemeId=${schemeId}` : "")+
        (filterText ? `&filterText=${filterText}` : "")
        );
  }

  getLotteryName() {
    return this.httpClient.get<AllotmentLetterListModel>(ApiUrls.lotteryNameList);
  }

  getSchemeName(lotteryEventId: number) {
    return this.httpClient.get<AllotmentLetterListModel>(ApiUrls.schemeCodeList.replace(`{lotteryEventId}`, lotteryEventId.toString()));
  }

  fetchSchemeList(page: number, size: number, filterText: any) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<AllotmentLetterListModel>>(
      ApiUrls.schemeList + reqParams
    );
  }

  update(appId : number, base64: string) {
    // console.log("Inner Method", base64);

    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateCasteValidity.replace("{appId}", appId.toString())}`,
      base64
    );
  }

  getPaymentExtensionList(
    lotteryEventId: number,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` + `&lotteryEventId=${lotteryEventId}`+
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<AppealDetailModel>>(
      ApiUrls.getPaymentExtensionList
         + reqParams
    );
  }

  fetchPaymentDetails(applicationNo: number) {
    return this.httpClient.get<InstallmentExtendModel>(
      ApiUrls.fetchPaymentDetails
        .replace("{applicationNo}", applicationNo.toString())
    );
  }

  initPagePayment() {
    return this.httpClient.get<{lotteryList: {[key: number]: string}, status: string, errorMessage: string}>(ApiUrls.paymentExtensionListInitUrl);
  }

  savePaymentExtension(installmentAppealModel: InstallmentAppealModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.savePaymentExtension}`,
      installmentAppealModel
    );
  }
 
  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

  getNewPaymentExtensionList(
    page: number,
    size: number,
    lotteryEventId: number,
    schemeKey:number,
    installmentType:string,
    filterText?: string,
    selectedDueDate?:string,
    
  ) {
    let reqParams =
      `?page=${page}&size=${size}` + `&lotteryEventId=${lotteryEventId}`+ `&schemeKey=${schemeKey}`+`&installmentType=${installmentType}`+
      (filterText ? `&filterText=${filterText}` : "" )+(selectedDueDate ? `&selectedDueDate=${selectedDueDate}` : "" );
    return this.httpClient.get<Page<PaymentSettlementModelPageWrapper>>(
      ApiUrls.getNewPaymentExtensionList
         + reqParams
    );
  }

}
